<template>
  <BaseCard>
    <div :class="$style.wrapper">
      <div :class="$style.slots">
        <div
          v-for="time in times"
          :key="time"
          :class="$style.slot"
        >
          {{ time }}
        </div>
      </div>
      <div
        :class="$style.appointment"
        :style="{ gridRowEnd }"
        v-html="exampleAppointment"
      />
    </div>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import dayjs from '@/dayjs';
import filters from '@/filters';
import createItem from '@/modules/calendar/calendar/calendar-content/CreateCalendarItem';
import { useThemeStore } from '@/stores/theme';

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    interval: 5 | 10 | 15 | 30;
    bufferTime: number;
    hasBufferTime: boolean;
  }>(),
  {
    bufferTime: 0,
    hasBufferTime: false,
  },
);

const exampleAppoinmentDurationMinutes = computed(
  () => 60 + (props.hasBufferTime ? props.bufferTime || 0 : 0),
);

const gridRowEnd = computed(() =>
  Math.floor(
    Math.floor(exampleAppoinmentDurationMinutes.value / props.interval) + 1,
  ),
);

const startTime = computed(() => dayjs().hour(10).minute(0).second(0));

const times = computed(() =>
  Array.apply(
    null,
    Array(Math.floor(exampleAppoinmentDurationMinutes.value / props.interval)),
  ).map((_x, i) =>
    filters.time(startTime.value.add(i * props.interval, 'minutes')),
  ),
);

const { darkerColors } = useThemeStore();

const exampleAppointment = computed(() => {
  const event = {
    title: t('admin.calendar.mock_service_name'),
    startStr: startTime.value,
    endStr: startTime.value.add(
      exampleAppoinmentDurationMinutes.value,
      'minutes',
    ),
    isSmall: gridRowEnd.value <= 3,
    darkerColors,
    extendedProps: {
      type: 'appointment',
      color: '#EB4762',
    },
    duration: exampleAppoinmentDurationMinutes.value,
  };
  return createItem({
    event,
    bufferTime: props.hasBufferTime ? props.bufferTime : 0,
  });
});
</script>

<style
  lang="scss"
  module
>
$slotWidth: 60px;

.wrapper {
  display: flex;
}

.slots {
  width: $slotWidth;
}

.slot {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-secondary);
  height: 28px;
  border: 1px solid var(--color-border);
  border-bottom: none;
  font-size: 12px;

  &:first-child {
    color: var(--color-text);
  }

  &:last-child {
    border-bottom: 1px solid var(--color-border);
  }
}

.appointment {
  width: calc(100% - #{$slotWidth});
}
</style>
